/** Relative URL for org-scoped object history (open in a new tab). */
export function objectHistoryUrl(entityKey: string): string {
  return `/object-history?entity=${encodeURIComponent(entityKey)}`;
}
